<div class="setting-container">
  <app-mobile-header [title]="'menu.settings'" [manualBackEvent]="true"
    (onManualBackEvent)="onClickBack()"></app-mobile-header>

  <div class="setting-tab" (click)="onNavigate('privacyPolicy')">
    <span>{{'label.privacy.policy' | translate}}</span>
    <i class="icon-chevron-right"></i>
  </div>

  <div class="setting-tab" (click)="onNavigate('tnc')">
    <span>{{'label.terms.and.conditions' | translate}}</span>
    <i class="icon-chevron-right"></i>
  </div>

  <div class="setting-tab" (click)="displayLanguageDialog = true">
    <span>{{'label.language' | translate}}</span>
    <span class="current-lang">{{currentLang | languageDesc : true}}<i class="icon-chevron-right"></i></span>
  </div>
</div>

<p-dialog position="bottom" [(visible)]="displayLanguageDialog" [baseZIndex]="999999999999"
  *ngIf="displayLanguageDialog" [modal]="false" [dismissableMask]="true" [blockScroll]="true"
  styleClass="fullScreen-dialog fullScreenWithBlack-dialog">
  <app-language [isStoreLang]="true" (changeLanguage)="displayLanguageDialog = false;" class="content">
  </app-language>
</p-dialog>
